/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Address } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';

export interface IShippingAddressProps {
    address: Address;
    resource: {
        shipToLabel: string;
    };
}
// @ts-ignore
const ShippingAddress: React.SFC<IShippingAddressProps> = ({ address, resource: { shipToLabel } }) => (
    <div className='shipping-address'>
        <div className='shipping-address-header'>{shipToLabel}</div>
        <div className='shipping-address-paragraph'>
            {address.Name && <span className='shipping-address-name'>{address.Name}</span>}
            <span>
                {address.StreetNumber && <span className='shipping-address-streetnumber'>{address.StreetNumber} </span>}
                {address.Street && <span className='shipping-address-street'>{address.Street} </span>}
            </span>
            {address.City && (
                <span className='shipping-address-location'>
                    <span className='shipping-address-city'>{address.City}</span>
                    {address.State && <span className='shipping-address-state'>{` ${address.State}`.toUpperCase()}</span>}
                </span>
            )}
            {address.ZipCode && (
                <span className='shipping-address-location'>
                    {address.ZipCode && <span className='shipping-address-zipcode'>{` ${address.ZipCode}`}</span>}
                </span>
            )}
            {address.Phone && <span className='shipping-address-phone'>{address.Phone}</span>}
        </div>
    </div>
);

export default ShippingAddress;
